import React from 'react';

const NotificationIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M20.1873 14.06L19.0573 12.18C18.8073 11.77 18.5873 10.98 18.5873 10.5V8.63005C18.5873 5.00005 15.6373 2.05005 12.0173 2.05005C8.38727 2.06005 5.43727 5.00005 5.43727 8.63005V10.49C5.43727 10.97 5.21727 11.76 4.97727 12.17L3.84727 14.05C3.41727 14.78 3.31727 15.61 3.58727 16.33C3.85727 17.06 4.46727 17.64 5.26727 17.9C6.34727 18.26 7.43727 18.52 8.54727 18.71C8.65727 18.73 8.76727 18.74 8.87727 18.76C9.01727 18.7801 9.16727 18.8 9.31727 18.82C9.57727 18.8601 9.83727 18.89 10.1073 18.91C10.7373 18.97 11.3773 19 12.0173 19C12.6473 19 13.2773 18.97 13.8973 18.91C14.1273 18.89 14.3573 18.8701 14.5773 18.84C14.7573 18.82 14.9373 18.8001 15.1173 18.7701C15.2273 18.76 15.3373 18.74 15.4473 18.72C16.5673 18.54 17.6773 18.26 18.7573 17.9C19.5273 17.64 20.1173 17.06 20.3973 16.32C20.6773 15.57 20.5973 14.75 20.1873 14.06ZM12.7473 10C12.7473 10.42 12.4073 10.76 11.9873 10.76C11.5673 10.76 11.2273 10.42 11.2273 10V6.90005C11.2273 6.48005 11.5673 6.14005 11.9873 6.14005C12.4073 6.14005 12.7473 6.48005 12.7473 6.90005V10Z'
        fill='#232222'
      />
      <path
        d='M14.8297 20.01C14.4097 21.17 13.2997 22 11.9997 22C11.2097 22 10.4297 21.68 9.87969 21.11C9.55969 20.81 9.31969 20.41 9.17969 20C9.30969 20.02 9.43969 20.03 9.57969 20.05C9.80969 20.08 10.0497 20.11 10.2897 20.13C10.8597 20.18 11.4397 20.21 12.0197 20.21C12.5897 20.21 13.1597 20.18 13.7197 20.13C13.9297 20.11 14.1397 20.1 14.3397 20.07C14.4997 20.05 14.6597 20.03 14.8297 20.01Z'
        fill='#232222'
      />
    </svg>
  );
};

export default NotificationIcon;
